import React, { useState } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { IoCloudUploadOutline } from "react-icons/io5";
import { BsFolder } from "react-icons/bs";
import { CiFolderOn } from "react-icons/ci";

const UploadFileModal = ({ show, handleClose, fetchCloud, project_id, folder_path }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const CloseModal = () => {
        setSelectedFiles([]);
        handleClose();
        setErr({ message: "", display: false });
    }

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
    };

    const ClickInput = () => {
        document.getElementById("upload_file_input").click();
    };

    const HandleSave = async () => {
        if (!selectedFiles.length) return;

        setLoading(true);
        setErr({ message: "", display: false });

        const formData = new FormData();
        formData.append("user_id", user_id);
        formData.append("folder_path", folder_path);
        formData.append("project_id", project_id);
        selectedFiles.forEach((file) => formData.append("files", file));

        try {
            const response = await fetch("https://backend.erioon.com/save_cloud_files", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (response.ok) {
                CloseModal()
                if (folder_path) {
                    fetchCloud()
                }
            } else {
                throw new Error(result.message || "Failed to upload files.");
            }
        } catch (error) {
            setErr({ message: error.message, display: true });
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={handleClose} className="modal_edit">
            <div className="modal_body">
                {!selectedFiles.length ? (
                    <div className="upload_file_modal_body">
                        <p>{t.cloud.choose_file_title}</p>
                        <button className="upload_file_btn" onClick={ClickInput}>
                            <BsFolder /> {t.cloud.choose_file_btn}
                        </button>
                        <input
                            type="file"
                            id="upload_file_input"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />
                    </div>
                ) : (
                    <div className="selected_files_modal_body">
                        <p>{t.cloud.selected_files}</p>
                        <div className="selected_files_cont">
                            {selectedFiles.map((file, index) => (
                                <p key={index}>
                                    {file.name}
                                    <button onClick={() => handleRemoveFile(index)}><i className="fa-solid fa-x"></i></button>
                                </p>
                            ))}
                        </div>
                    </div>
                )}
                <div className="choose_folder">
                    <p><CiFolderOn /> {folder_path}</p>
                </div>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={err} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={HandleSave}
                        disabled={!selectedFiles.length}
                    >
                        {loading ? <Spinner loading={loading} /> : <><IoCloudUploadOutline /> {t.cloud.upload}</>}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default UploadFileModal;
